import React from 'react';
import { Box, Container, Typography, Grid, Paper } from '@mui/material';
import { motion } from 'framer-motion';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import CampaignIcon from '@mui/icons-material/Campaign';
import HandshakeIcon from '@mui/icons-material/Handshake';

const BusinessFunnel = () => {
  const steps = [
    {
      title: '1. Extrae y Segmenta',
      desc: 'Encuentra leads cualificados de tu nicho con la herramienta de Lead Scraping. Extrae correos, teléfonos y datos de empresas en segundos.',
      icon: PeopleIcon,
      color: '#E67E22'
    },
    {
      title: '2. Gestiona con CRM',
      desc: 'Importa tus leads directamente al Formark CRM. Crea embudos visuales, automatiza seguimientos por email y cierra ventas con métricas en tiempo real.',
      icon: AutoGraphIcon,
      color: '#3B207F'
    },
    {
      title: '3. Publica y Comunica',
      desc: 'Usa la gestión de RRSS para crear campañas de contenido que atraigan a tu público objetivo. Gestiona todas tus redes desde un solo panel.',
      icon: CampaignIcon,
      color: '#29B6F6'
    },
    {
      title: '4. Contrata Talento',
      desc: 'Cuando crezcas, encuentra profesionales verificados en la Bolsa de Profesionales. Revisa portafolios, certificaciones y reseñas antes de contratar.',
      icon: HandshakeIcon,
      color: '#00A86B'
    },
    {
      title: '5. Escala sin Límites',
      desc: 'Coordina proyectos con tu equipo en los tableros Kanban, comunícate por el chat integrado y repite el ciclo para crecer exponencialmente.',
      icon: TrendingUpIcon,
      color: '#F21C63'
    }
  ];

  return (
    <Box sx={{ background: '#0B0914', py: 10, color: '#fff', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          <Grid item xs={12} md={5}>
            <motion.div initial={{ opacity: 0, x: -50 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
              <Typography variant="caption" sx={{ color: '#F21C63', fontWeight: 'bold', letterSpacing: 1 }}>PARA EMPRESAS</Typography>
              <Typography variant="h3" fontWeight={800} mt={2} mb={3}>
                Crecimiento Acelerado para tu Negocio
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.7)', mb: 4, lineHeight: 1.8 }}>
                Hitpoly está diseñado como un motor de crecimiento para empresas modernas. No necesitas contratar cinco herramientas diferentes. Centraliza la adquisición de clientes, la gestión de ventas y la contratación de personal en un ecosistema que trabaja de forma colaborativa.
              </Typography>
            </motion.div>
          </Grid>
          
          <Grid item xs={12} md={7}>
            <Box sx={{ position: 'relative' }}>
              {/* Línea conectora */}
              <Box sx={{ position: 'absolute', left: '39px', top: '20px', bottom: '20px', width: '2px', background: 'linear-gradient(180deg, #E67E22, #3B207F, #00A86B)' }} />
              
              {steps.map((step, index) => (
                <motion.div 
                  key={index}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: index * 0.2 }}
                >
                  <Box sx={{ display: 'flex', gap: 3, mb: index !== steps.length - 1 ? 4 : 0, position: 'relative', zIndex: 1 }}>
                    <Box 
                      sx={{ 
                        width: 80, 
                        height: 80, 
                        borderRadius: '50%', 
                        background: '#13111C',
                        border: `2px solid ${step.color}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: step.color,
                        flexShrink: 0
                      }}
                    >
                      <step.icon fontSize="large" />
                    </Box>
                    <Paper 
                      elevation={0}
                      sx={{ 
                        p: 3, 
                        background: 'rgba(255,255,255,0.03)', 
                        border: '1px solid rgba(255,255,255,0.05)', 
                        borderRadius: '16px',
                        flexGrow: 1
                      }}
                    >
                      <Typography variant="h6" fontWeight="bold" mb={1}>{step.title}</Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.6)' }}>{step.desc}</Typography>
                    </Paper>
                  </Box>
                </motion.div>
              ))}
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default BusinessFunnel;
